module.exports = __webpack_public_path__ + "static/media/rpas.3b9dc272.svg";